import React, { Component } from 'react';
import { Container, Card, Icon, Grid } from 'semantic-ui-react';
import scrollToElement from 'scroll-to-element';

class Navigation extends Component {
  render() {
    const { antallFordeler } = this.props;
    return (
      <Container>
        <Card.Group itemsPerRow={4} doubling stackable className="navigasjon">
          <Card link color="yellow" onClick={this.onClickMedlemsfordeler}>
            <Card.Content>
              <Grid verticalAlign="middle">
                <Grid.Column floated="left" width={11}>
                  {antallFordeler} medlems&shy;fordeler
                </Grid.Column>
                <Grid.Column floated="right" textAlign="right" width={5}>
                  <Icon name="angle right" size="large" />
                </Grid.Column>
              </Grid>
            </Card.Content>
          </Card>
          <Card link color="yellow" onClick={this.onClickReferanser}>
            <Card.Content>
              <Grid verticalAlign="middle">
                <Grid.Column floated="left" width={10}>
                  Derfor er vi medlem
                </Grid.Column>
                <Grid.Column floated="right" textAlign="right" width={5}>
                  <Icon name="angle right" size="large" />
                </Grid.Column>
              </Grid>
            </Card.Content>
          </Card>
          <Card link color="yellow" onClick={this.onClickBliKontaktet}>
            <Card.Content>
              <Grid verticalAlign="middle">
                <Grid.Column floated="left" width={10}>
                  Bli kontaktet
                </Grid.Column>
                <Grid.Column floated="right" textAlign="right" width={5}>
                  <Icon name="angle right" size="large" />
                </Grid.Column>
              </Grid>
            </Card.Content>
          </Card>
        </Card.Group>
      </Container>
    );
  }

  onClickMedlemsfordeler() {
    scrollToElement('#medlemsfordeler');
  }

  onClickReferanser() {
    scrollToElement('#medlemsreferanser');
  }

  onClickBliKontaktet() {
    scrollToElement('#bli-kontaktet');
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/LandingPage/Navigation.js